var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"mindsets-list-panel"}},[_c('vector-chart',{key:"mindsets-2-lg",attrs:{"maxWidth":"300","maxHeight":"300","isShowScale":"true","isShowText":"true","chartData":_vm.learnerVectors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }